import { defineComponent as _defineComponent } from 'vue'
import {ref} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MiaodouRule',
  setup(__props, { expose }) {
  expose();

const useList = ref<string[]>([
    '1、苗豆可以用来体验平台功能，开通会员更放心。',
    '2、苗豆可以用来全部刷新，使供应商品排名靠前。',
    '3、苗豆可以用来查看求购电话号码，把握商机，机不可失。',
    '4、苗豆可以用来报价，全面撒网，重点捕捞。',
]);

const __returned__ = { useList, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})